export default __webpack_public_path__ + "static/media/nissan.d21c0e8b.svg";